import { COST_CENTER as LABELS } from './labels.js';

export default {
  data: [],
  page: {
    currentPage: 1,
    total: 0,
    pageSize: 10
  },
  option: {
    refreshBtn: false,
    indexLabel: LABELS.serialNumber,
    indexFixed: false,
    searchShow: false,
    searchBtn: true,
    columnBtn: false,
    align: 'center',
    menu: false,
    border: true,
    highlightCurrentRow: true,
    selection: true,
    stripe: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    index: true,
    sortable: true,
    tip: false,
    indeterminate: true,
    searchSpan: 12,
    searchMenuSpan: 12,
    column: [
      {
        label: LABELS.costCenterCode,
        prop: 'costCenterCode',
        search: true,
        overHidden: true
      },
      {
        label: LABELS.name,
        prop: 'costCenterDesc',
        search: true,
        overHidden: true
        // supplierName
      },
      {
        label: LABELS.email,
        prop: 'email',
        overHidden: true
        // supplierName
      },
      {
        label: LABELS.phoneNumber,
        prop: 'telphone',
        overHidden: true
        // supplierName
      }
    ]
  }
};
